/**
 * Standardized error contexts for consistent error reporting
 */
export const ERROR_CONTEXTS = {
    // Authentication & Authorization
    AUTH_INITIALIZATION: "auth.initialization",
    AUTH_LOGIN: "auth.login",
    AUTH_LOGOUT: "auth.logout",
    AUTH_TOKEN_VALIDATION: "auth.token_validation",
    // Payment Processing
    PAYMENT_INITIALIZATION: "payment.initialization",
    PAYMENT_DATA_LOADING: "payment.data_loading",
    PAYMENT_PROCESSING: "payment.processing",
    PAYMENT_SESSION_CREATION: "payment.session_creation",
    // Adyen Integration
    ADYEN_INITIALIZATION: "adyen.initialization",
    ADYEN_COMPONENT_MOUNTING: "adyen.component_mounting",
    ADYEN_DROP_IN_RETRIEVAL: "adyen.drop_in_retrieval",
    // Onboarding
    ONBOARDING_LINK_CREATION: "onboarding.link_creation",
    ONBOARDING_PROCESS: "onboarding.process",
    // Transactions
    TRANSACTION_INITIALIZATION: "transaction.initialization",
    TRANSACTION_SELECTION: "transaction.selection",
    TRANSACTION_COMPONENT_MOUNTING: "transaction.component_mounting",
    // Recurring Payment Rules (Subscriptions)
    RECURRING_PAYMENT_RULES_LIST: "recurring_payment_rules.list",
    RECURRING_PAYMENT_RULES_SEARCH: "recurring_payment_rules.search",
    RECURRING_PAYMENT_RULE_CANCEL: "recurring_payment_rules.cancel",
    RECURRING_PAYMENT_RULE_UPDATE: "recurring_payment_rules.update",
    // API Calls
    API_ORGANIZATION_INFO: "api.organization_info",
    API_PAYMENT_DETAILS: "api.payment_details",
    API_PAYMENT_SESSION: "api.payment_session",
    DATA_FETCH: "api.data_fetch",
    PAYMENT_CANCELLATION: "payment.cancellation",
    PAYMENT_UPDATE: "payment.update",
    // Network & General
    NETWORK_CONNECTION: "network.connection",
    DATA_VALIDATION: "data.validation",
    COMPONENT_LIFECYCLE: "component.lifecycle",
};
/**
 * Error types and their navigation behavior mapping
 * Note: PAYMENT_ERROR navigation is controlled by ErrorHandler (e.g., handlePaymentRefused)
 */
export const ERROR_NAVIGATION_MAP = {
    NETWORK_ERROR: true, // Critical - navigate to error page
    API_ERROR: true, // Critical - navigate to error page
    AUTHENTICATION_ERROR: true, // Critical - navigate to error page
    AUTHORIZATION_ERROR: true, // Critical - navigate to error page
    SERVER_ERROR: true, // Critical - navigate to error page
    VALIDATION_ERROR: false, // Non-critical - handle inline
    PAYMENT_ERROR: false, // Non-critical by default (inline), but specific handlers may force navigation
    UNKNOWN_ERROR: true, // Default to critical
};
/**
 * Error severity levels for better categorization
 */
export const ERROR_SEVERITY = {
    LOW: "low",
    MEDIUM: "medium",
    HIGH: "high",
    CRITICAL: "critical",
};
/**
 * Common error message translation keys for consistency
 */
export const ERROR_MESSAGE_KEYS = {
    NETWORK_UNAVAILABLE: "error.messages.networkUnavailable",
    API_SERVER_ERROR: "error.messages.apiServerError",
    AUTHENTICATION_REQUIRED: "error.messages.authenticationRequired",
    AUTHORIZATION_DENIED: "error.messages.authorizationDenied",
    VALIDATION_FAILED: "error.messages.validationFailed",
    UNKNOWN_ERROR: "error.messages.unknownError",
};
